export default __webpack_public_path__ + "static/media/ic-warning.e8d559f0.svg";